/**
 * Created by Bob.Gear on 12/02/2022.
 */
//------------------------------------------------------------------------
//  fidDateFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('fidDateFilterController',
        [
            '$scope',
            function($scope) {
                $scope.componentName = "fidDateFilter";


                $scope.resetFilter = function () {
                    $scope.clearFIDDateFrom();
                    $scope.clearFIDDateTo();
                    delete $scope.criteria["fidDateFrom"];
                    delete $scope.criteria["fidDateTo"];

                    $scope.criteria.includeFidExpected = null;
                    delete $scope.criteria["includeFidExpected"];

                    $scope.criteria.includeFidReceived = false;
                    delete $scope.criteria["includeFidReceived"];

                    $scope.criteria.includeProjectsWithFidData = true;
                };

                $scope.removeFilter = function() {
                    $scope.resetFilter();
                    $scope.$parent.removeFilter("#fidDateFilter");
                };

                $scope.$watch("criteria.fidDateToRaw",
                    function() {
                        // when the end date changes, find the last date of the same month
                        // do this by creating a new date, adding a month and subtracting a day
                        if ($scope.criteria.fidDateToRaw) {
                            var firstDayOfEndMonth = $scope.criteria.fidDateToRaw;
                            $scope.criteria.fidDateTo = new Date(firstDayOfEndMonth.getFullYear(),
                                firstDayOfEndMonth.getMonth() + 1,
                                0);
                        }
                        verifyFormState();

                    });

                $scope.$watch("criteria.includeProjectsWithFidData",
                    function() {
                        // If the master include/exclude control changes to 'exclude'
                        // set the form state to 'pristine' so that  the search function
                        // will be enabled; the contents of the other (now hidden) controls 
                        // is irrelevant now
                        if (!$scope.criteria.includeProjectsWithFidData) {
                            $scope.fidDateFilterForm.$setDirty();
                            $scope.fidDateFilterForm.$setValidity("$valid", true);
                        }

                    });

                $scope.clearFIDDateFrom = function() {
                    $scope.criteria.fidDateFrom = null;

                    // set the element pristine
                    verifyFormState();
                };

                $scope.clearFIDDateTo = function() {
                    $scope.criteria.fidDateToRaw = null;
                    $scope.criteria.fidDateTo = null;

                    // set the form pristine
                    verifyFormState();
                };

                var verifyFormState = function() {
                    if (!$scope.criteria.fidDateFrom &&
                        !$scope.criteria.fidDateTo &&
                        !$scope.criteria.includeFidExpected &&
                        $scope.criteria.includeFidReceived) {
                        $scope.fidDateFilterForm.$setPristine();
                    }
                };

                $scope.showInvalidMessage = function() {
                    var showMessage;
                    if (!$scope.fidDateFilterForm) return false;
                    if (!$scope.criteria.includeProjectsWithFidData) return false;

                    // The current date entry control handles invalid dates internally - so it is not necessary to process
                    // this here. A future version might  need more handling - so I am leaving this here.
                    // Instead we have rather simpler pristine detection which only shows the mssage if the user has
                    // interacted with the form then set both dates to null
                    showMessage = ($scope.fidDateFilterForm.$dirty &&
                        !$scope.criteria.fidDateFrom &&
                        !$scope.criteria.fidDateTo);

                    // showMessage is also true if both dates are set and the from date is larger than the to date
                    showMessage = showMessage || ($scope.criteria.fidDateFrom > $scope.criteria.fidDateTo);


                    $scope.fidDateFilterForm.$setValidity("$valid",
                        !(showMessage || $scope.fidDateFilterForm.$pristine));

                    return showMessage;
                };

                $scope.ignoreKeypress = function(e) {
                    e.preventDefault();
                    return false;
                };


                // Set up starting defaults
                // ------------------------
                // If the property is undefined, then the filter is being added 
                // fresh and the default value should be set. If there is already 
                // a value, then we are dealing with a saved search and the default 
                // value should be ignored.
                // There doesn't seem t o be a more general way of determining 
                // if this is the case (say, a single property to test that would 
                // apply to all default values)
                if (typeof $scope.criteria.includeFidReceived === 'undefined') {
                    $scope.criteria.includeFidReceived = true;
                }
                if (typeof $scope.criteria.includeProjectsWithFidData === 'undefined') {
                    $scope.criteria.includeProjectsWithFidData = true;
                }

            }
        ])
    .directive('fidDateFilter',
        [
            '$compile',
            function($compile) {
                return {
                    replace: true, // replace the placeholder element with the template
                    restrict: 'A', // usage: <div projectNameFilter />
                  templateUrl: "../app-ds3/search/queryBuilder/filters/fidDateFilter.tmpl.html",

                    link: function($scope, iElement, iAttrs) {
                        if ($scope.criteria.fidDateFrom
                            || $scope.criteria.fidDateTo
                            || $scope.criteria.includeFidExpected
                            || $scope.criteria.includeFidReceived
                                || !$scope.criteria.includeProjectsWithFidData) {
                            $scope.fidDateFilterForm.$setDirty();
                        }
                    },

                    controller: 'fidDateFilterController'
                };
            }
        ]);
//------------------------------------------------------------------------

